import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      portfolio: {
        common: {
          SUMMARY: 'Summary',
          BY_FINANCE: 'By Finance',
          BY_SCORE: 'By Score',
          BY_SEGMENT: 'By Segment',
          PORTFOLIO_SUMMARY: 'Portfolio Summary',
          PORTFOLIO_BY_FINANCE: 'Portfolio By Finance',
          PORTFOLIO_BY_SCORE: 'Portfolio By Score',
          PORTFOLIO_BY_SEGMENT: 'Portfolio By Segment',
          MANAGE_YOUR_PORTFOLIO: 'Manage Your Portfolio',
          CREATE_DYNAMIC_REPORT: 'Create Dynamic Report',
          LIST_OF_COMPANIES: 'List of Companies',
          SELECTED: 'selected',
          SELECT_ALL: 'Select all ',
          ITEM: ' items',
          UNSELECT_ALL: 'Unselect all items',
          COPY: 'Copy to portfolio',
          LAST_UPDATE_DATE: 'Last update date',
          PERIOD: 'Period',
          YEAR: 'Yearly',
          QUARTER: 'Quarterly',
          MONTH: 'Monthly',
          TOTAL_COMPANIES: 'Total Companies',
          HIGHEST_CREDIT_RISK_COMPANIES: 'Highest Risk Companies',
          NEW_HIGHEST_CREDIT_RISK_COMPANIES: 'New Highest Risk Companies',
          HIGHEST_GROWTH_POTENTIAL_COMPANIES:
            'Highest Growth Potential Companies',
          NEW_HIGHEST_GROWTH_POTENTIAL_COMPANIES:
            'New Highest Growth Potential Companies',
        },
        summary: {
          TOTAL_PORTFOLIOS: 'Total Portfolios',
          PORTFOLIO_COUNT: 'portfolio%{suffix}',
          SEPARATE_COMPANY_COUNT: 'separate companies',
          PORTFOLIO_OVERVIEW: 'Portfolio Overview',
          SCORE_DISTRIBUTION: 'Score Distribution',
          ALERTS: 'Alerts',
          PORTFOLIO_SEGMENTATION: 'Portfolio Segmentation',
          TOP_10_HIGHEST_RISK: 'Top 10 Highest Risk',
          TOP_10_HIGHEST_GROWTH_POTENTIAL: 'Top 10 Highest Growth Potential',
          FILTER_ARE_NOT_APPLIED: '(Filters are not applied)',
          ANALYSE: 'Analyse',
          VERSUS: 'Versus',
          CREDIT_RISK_SCORE: 'Corporate Risk Score',
          PERFORMANCE_SCORE: 'Performance Score',
          BUSINESS_SIZE: 'Business Size',
          BUSINESS_SIZE_NET_REVENUE: 'Business Size',
          YEARS_OF_OPERATION: 'Years in Operation',
          HIGH_RISK_COMPANIES: 'High Risk Companies',
          NUMBER_OF_COMPANIES: 'Number of Companies',
          PERCENT_OF_TOTAL_COMPANIES: '% of Total Companies',
          VIEW_COMPANY: 'View Company',
          TOTAL_COMPANY: 'Total',
          CREDIT_RISK_LEVEL_DISTRIBUTION: 'Corporate Risk Level Distribution',
          CREDIT_RISK_LEVEL: 'Corporate Risk Level',
          GROWTH_POTENTIAL_LEVEL_DISTRIBUTION:
            'Growth Potential Level Distribution',
          PERFORMANCE_SCORE_LEVEL: 'Performance Score Level',
          COMPANIES: 'Companies',
          OF_TOTAL_COMPANIES: 'of Total Companies',
          NEGATIVE_ALERT: 'Negative Alerts',
          UNREAD_ALERT: 'Unread Alerts',
          TOTAL_ALERT: 'Total Alerts',
          STT: '#',
          COMPANY: 'Company',
          SUBJECT: 'Subject',
          TYPE_DESCRIPTION: 'Type/Description',
          DATE: 'Date',
          PORTFOLIO: 'Portfolio',
          TRIGGER: 'Trigger',
          VIEW_BY: 'View by:',
          TOP_10_INDUSTRIES: 'Top 10 Industries by Number of Companies',
          TOP_10_INDUSTRIES_SUB: '(VSIC - Level 2)',
          COL_NUMBER_OF_COMPANIES: 'Number of<br/>Companies',
          COL_PERCENT_OF_TOTAL_COMPANIES: '% of Total<br/>Companies',
          INDUSTRY: 'Industry',
          TOP_10_PROVINCES: 'Top 10 Provinces by Number of Companies',
          PROVINCE: 'Province',
          BUSINESS_SIZE_DISTRIBUTION: 'Business Size Distribution',
          BUSINESS_SIZE_BY_REVENUE: 'Business Size',
          YEARS_OF_OPERATION_DISTRIBUTION: 'Years in Operation Distribution',
          HIGHEST_RISK_PORTFOLIOS: 'Highest Risk Portfolios',
          HIGHEST_RISK_PORTFOLIOS_NOTE:
            'Portfolios with the highest number of company classified as High risk, Very high risk and Near default.',
          HIGHEST_RISK_INDUSTRIES: 'Highest Risk Industries',
          HIGHEST_RISK_INDUSTRIES_SUB: '(VSIC - Level 2)',
          HIGHEST_RISK_INDUSTRIES_NOTE:
            'Industries with the highest number of company in all portfolios classified as High risk, Very high risk and Near default.',
          HIGHEST_GROWTH_POTENTIAL_PORTFOLIOS:
            'Highest Growth Potential Portfolios',
          HIGHEST_GROWTH_POTENTIAL_PORTFOLIOS_NOTE:
            'Portfolios with the highest number of companies classified as High Growth Potential.',
          HIGHEST_GROWTH_POTENTIAL_INDUSTRIES:
            'Highest Growth Potential Industries',
          HIGHEST_GROWTH_POTENTIAL_INDUSTRIES_SUB: '(VSIC - Level 2)',
          HIGHEST_GROWTH_POTENTIAL_INDUSTRIES_NOTE:
            'Industries with the highest number of company in all portfolios classified as High Growth Potential.',
          TOTAL_HIGHEST_RISK_COMPANIES: 'Total Highest<br/>Risk Companies',
          NEW_HIGHEST_RISK_COMPANIES: 'New Highest<br/>Risk Companies',
          HIGHEST_GROWTH_POTENTIAL_COMPANIES:
            'Highest Growth<br/>Potential Companies',
          NEW_HIGHEST_GROWTH_POTENTIAL_COMPANIES:
            'New Highest Growth<br/>Potential Companies',
          VIEW_ALL: 'View all',
        },
        finance: {
          DISPLAY_TYPE: 'Display by Type:',
          CORPORATE: 'Corporate',
          BANK: 'Bank',
          SECURITIES: 'Securities',
          LIFE_INSURANCE: 'Life Insurance',
          NON_LIFE_INSURANCE: 'Non-Life Insurance',
          NON_BANK: 'Non-bank Financial Institution',
          REPORT_YEAR: 'Reporting Year: ',
          COMPARE_WITH: 'Compare with: ',
          CURRENT_RATIO: 'Current ratio',
          TOTAL_ASSETS: 'Total Liabilities to Total Assets',
          CASH_CONVERSION: 'Cash Conversion Cycle',
          NET_REVENUE: 'Net Revenue Growth',
          CAPITAL_ADEQUACY: 'Capital Adequacy Ratio (CAR)',
          NET_INTEREST: 'Net Interest Margin',
          NON_PERFORMING: 'Non-Performing Loan Ratio',
          LOAN_DEPOSIT: 'Loans to Deposit (LDR)',
          STOCK_BOND: 'Stock and bond brokerage market share',
          LOAN_TOTAL: 'Loans to Total Equity',
          COST_INCOME: 'Cost to Income Ratio (CIR)',
          TOTAL_EQUITY: 'Total Liabilities to Total Equity',
          LIQUIDITY_SOLVENCY: 'Liquidity, Solvency and Coverage',
          ASSET_MANAGEMENT: 'Asset Management Efficiency',
          PROFITABILITY: 'Profitability',
          BUSINESS_GROWTH: 'Business Growth',
          CAPITAL_ADEQUACY_PANEL: 'Capital Adequacy',
          ASSET_QUALITY: 'Asset Quality',
          EARING_QUALITY: 'Earnings Quality',
          FUNDING_LIQUIDITY: 'Funding & Liquidity ',
          BUSINESS_POSITION: 'Business Position',
          CAPITAL_EARNING: 'Capital, Earning and Leverage',
          OVER_5_YEARS: ' over 5 years ',
          FILTERED_RATIO: 'Filtered Portfolio Ratio',
          COMPARE_RATIO:
            'Filtered Portfolio Ratio Compare with Other Portfolios',
          RATIO: 'Ratio',
          SHOW_ON_CHART: 'Show on chart',
          PORTFOLIO: 'Portfolio',
          MEDIAN_SCORE: 'Median',
          INTERQUARTILE_RANGE: 'Min | Max',
          MEDIAN_RATIO: 'Median of ratio',
          MAX_MIN_RATIO: 'Min - Max of ratio',
          SELECT_PORTFOLIO: 'Select portfolio',
          BLANK: 'Blank',
          CT_RT0020: 'Current Ratio',
          CT_RT0019: 'Quick Ratio',
          CT_RT0018: 'Cash Ratio',
          CT_RT0033: 'Total Liabilities to Total Assets',
          CT_RT0027: 'Total Debt to Total Equity ',
          CT_RT0037: 'Total Debt to EBITDA',
          CT_RT0047: 'Cash Interest Coverage',
          CT_RT0044: 'Interest Coverage',
          CT_RT0046: 'EBITDA Interest Coverage',
          CT_RT0045: 'Asset Coverage ',
          CT_RT0059: 'ROA',
          CT_RT0156: 'Net Revenue Growth',
          CT_RT0015: 'Cash Conversion Cycle',
          NH_NB219: 'Capital Adequacy Ratio (CAR)',
          NH_RT0236: 'Non-performing Loans Ratio',
          NH_RT0059: 'ROA',
          CK_SABBMS: 'Stock and bond brokerage market share',
          CK_RT0060: 'ROE',
          CK_LTTE: 'Loans to Total Equity',
          CK_CTIR: 'Cost to Income Ratio (CIR)',
          CK_RT0034: 'Total Liabilities to Total Equity',
          CT_RT0009: 'Days Sales Outstanding',
          CT_RT0011: 'Days Inventories Outstanding',
          CT_RT0013: 'Days Payable Outstanding',
          CT_RT0003: 'Assets Turnover',
          CT_RT0006: 'Fixed Assets Turnover',
          CT_RT0050: 'Gross Profit Margin',
          CT_RT0348: 'Operating Profit Margin',
          CT_RT0054: 'Net Profit Margin',
          CT_RT0052: 'EBIT Margin',
          CT_RT0051: 'EBITDA Margin',
          CT_RT0060: 'ROE ',
          CT_RT0161: 'Net Profit After Tax Growth',
          CT_RT0159: 'EBIT Growth ',
          CT_RT0387: 'Fixed Assets Growth ',
          CT_RT0172: 'Total Asset Growth',
          CT_RT0174: "Total Owner's Equity Growth",
          NH_RT0249: 'Common Equity Tier-1 Capital to Total Assets',
          NH_RT0248: 'Total Equity to Total Assets',
          NH_RT0266: 'Total Loans To Total Assets',
          NH_RT0237: 'Loan Loss Provision to NPLs',
          NH_RT0238: 'Loan Loss Provision to Total Loans ',
          NH_RT0285: 'Net Interest Margin (NIM)',
          NH_RT0252: 'Cost to Income Ratio (CIR)',
          NH_RT0060: 'ROE ',
          NH_RT0277: 'Loans to Deposit (LDR)',
          NH_LATL: 'Liquid Asset to Total Liability',
          NH_RT0287: 'Average Cost of Financing',
          NH_RT0173: 'Total Equity Growth',
          NH_RT0172: 'Total Assets Growth',
          NH_RT0296: 'Gross Loan to Customer Growth',
          NH_RT0161: 'Net Income Growth',
          CK_OSBMS: 'Other securities brokerage market share',
          CK_RT0059: 'ROA',
          CK_CIR: 'Cost to Income Ratio (CIR)',
          CK_LTE: 'Loans to Total Equity',
          CK_STF: 'Short Term Funding',
          CK_LTF: 'Long Term Funding',
          CK_LTFLA: 'Long-term funding/ Illiquid assets',
          CK_LASTF: 'Liquid assets / Short-term funding',
        },
        score: {},
        segment: {
          PORTFOLIO_ALLOCATION_BY_PROVINCE2: 'Portfolio Allocation By Province',
          PORTFOLIO_ALLOCATION_BY_PROVINCE: 'Portfolio Allocation By Province',
          BUSINESS_SIZE: 'Business Size',
          BASED_ON_VSIC: 'Industry based on VSIC',
          PERFORMANCE_SCORE: 'Performance Score',
          PERFORMANCE_SCORE_DYNAMIC: 'Performance Score',
          BY_INDUSTRY: 'Portfolio Allocation By Industry',
          LAST_UPDATE_DATE: 'Last update date: ',
          VIET_NAM: 'Vietnam',
          MEDIAN_SCORE: 'Median score',
          TOTAL_COMPANIES: 'Total Companies',
          MAIN_PROVINCE: 'Main Province',
          MAIN_SECTOR: 'Main sector',
          MOST_BUSINESS_SIZE: 'Most Popular Business Size',
          YEARS_OF_OPERATION: 'Most Popular Years in Operation',
          BUSINESS_SIZE_BY_REVENUE: 'Business Size Distribution',
          BASE_ON: ' (based on the business registration date)',
          YEARS_OF_OPERATION_DISTRIBUTION: 'Years in Operation Distribution',
          CREDIT_RISK_SCORE: 'Corporate Risk Score',
          CREDIT_RISK_SCORE_DYNAMIC: 'Corporate<br/> Risk Score',
          REVENUE: 'Revenue',
          YEARS_OF_OPERATION_COL: 'Years in Operation',
          HIGH_RISK_COMPANIES: 'High Risk Companies',
          NUMBER_OF_COMPANIES: 'Number of Companies',
          NUMBER_OF_COMPANIES_DYNAMIC: 'Number of<br/> Companies',
          PERCENT_OF_TOTAL_COMPANIES: '% of Total Companies',
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      portfolio: {
        common: {
          SUMMARY: 'Tổng Quan',
          BY_FINANCE: 'Chỉ Số Tài Chính',
          BY_SCORE: 'Thống Kê Điểm',
          BY_SEGMENT: 'Thống Kê Theo Yếu Tố Khác',
          PORTFOLIO_SUMMARY: 'Tổng quan danh mục',
          PORTFOLIO_BY_FINANCE: 'Chỉ số tài chính của danh mục',
          PORTFOLIO_BY_SCORE: 'Thống kê danh mục theo điểm',
          PORTFOLIO_BY_SEGMENT: 'Thống kê danh mục theo yếu tố khác',
          MANAGE_YOUR_PORTFOLIO: 'Quản Lý Danh Mục',
          CREATE_DYNAMIC_REPORT: 'Tạo Dynamic Report',
          LIST_OF_COMPANIES: 'Danh sách công ty',
          SELECTED: 'Đã chọn',
          SELECT_ALL: 'Chọn tất cả ',
          ITEM: ' bản ghi',
          UNSELECT_ALL: 'Bỏ chọn tất cả',
          COPY: 'Sao chép tới danh mục',
          LAST_UPDATE_DATE: 'Ngày cập nhật',
          PERIOD: 'Hiển thị',
          YEAR: 'Theo năm',
          QUARTER: 'Theo quý',
          MONTH: 'Theo tháng',
          TOTAL_COMPANIES: 'Số lượng công ty',
          HIGHEST_CREDIT_RISK_COMPANIES: 'Công ty có mức rủi ro cao',
          NEW_HIGHEST_CREDIT_RISK_COMPANIES: 'Công ty có mức rủi ro cao mới',
          HIGHEST_GROWTH_POTENTIAL_COMPANIES:
            'Công ty có triển vọng tăng trưởng cao',
          NEW_HIGHEST_GROWTH_POTENTIAL_COMPANIES:
            'Công ty có triển vọng tăng trưởng cao mới',
        },
        summary: {
          TOTAL_PORTFOLIOS: 'Tất cả danh mục',
          PORTFOLIO_COUNT: 'danh mục',
          SEPARATE_COMPANY_COUNT: 'công ty',
          PORTFOLIO_OVERVIEW: 'Tổng quan danh mục',
          SCORE_DISTRIBUTION: 'Phân bổ theo mức điểm',
          ALERTS: 'Cảnh báo',
          PORTFOLIO_SEGMENTATION: 'Phân khúc danh mục',
          TOP_10_HIGHEST_RISK: 'Top 10 Danh mục & Ngành rủi ro cao nhất',
          TOP_10_HIGHEST_GROWTH_POTENTIAL:
            'Top 10 Danh mục & Ngành có triển vọng tăng trưởng cao nhất',
          FILTER_ARE_NOT_APPLIED: '(Không áp dụng bộ lọc)',
          ANALYSE: 'Phân tích',
          VERSUS: 'So với',
          CREDIT_RISK_SCORE: 'Điểm Rủi Ro Doanh Nghiệp',
          PERFORMANCE_SCORE: 'Điểm Triển Vọng Tăng Trưởng',
          BUSINESS_SIZE: 'Quy Mô',
          BUSINESS_SIZE_NET_REVENUE: 'Quy Mô',
          YEARS_OF_OPERATION: 'Số Năm Hoạt Động',
          HIGH_RISK_COMPANIES: 'Nhóm công ty rủi ro cao',
          NUMBER_OF_COMPANIES: 'Số lượng công ty',
          PERCENT_OF_TOTAL_COMPANIES: '% Tỷ trọng',
          VIEW_COMPANY: 'Xem danh sách công ty',
          TOTAL_COMPANY: 'Tổng',
          CREDIT_RISK_LEVEL_DISTRIBUTION:
            'Phân Bổ Mức Điểm Rủi Ro Doanh nghiệp',
          CREDIT_RISK_LEVEL: 'Điểm rủi ro doanh nghiệp',
          GROWTH_POTENTIAL_LEVEL_DISTRIBUTION:
            'Phân Bổ Mức Điểm Triển Vọng Tăng Trưởng',
          PERFORMANCE_SCORE_LEVEL: 'Mức Triển Vọng Tăng Trưởng',
          COMPANIES: 'Công ty',
          OF_TOTAL_COMPANIES: 'Danh mục',
          NEGATIVE_ALERT: 'Cảnh báo tiêu cực',
          UNREAD_ALERT: 'Cảnh báo chưa đọc',
          TOTAL_ALERT: 'Tổng số cảnh báo',
          STT: '#',
          COMPANY: 'Công Ty',
          SUBJECT: 'Đối Tượng',
          TYPE_DESCRIPTION: 'Loại Cảnh Báo/Mô Tả',
          DATE: 'Ngày',
          PORTFOLIO: 'Danh Mục',
          TRIGGER: 'Tập Cảnh Báo',
          VIEW_BY: 'Xem theo:',
          TOP_10_INDUSTRIES: 'Top 10 ngành theo số lượng doanh nghiệp',
          TOP_10_INDUSTRIES_SUB: '(VSIC - Cấp 2)',
          COL_NUMBER_OF_COMPANIES: 'Số Lượng<br/>Công Ty',
          COL_PERCENT_OF_TOTAL_COMPANIES: '% Tỷ Trọng',
          INDUSTRY: 'Ngành',
          TOP_10_PROVINCES: 'Top 10 tỉnh/ thành phố theo số lượng doanh nghiệp',
          PROVINCE: 'Tỉnh/Thành Phố',
          BUSINESS_SIZE_DISTRIBUTION: 'Phân bổ theo quy mô doanh thu',
          BUSINESS_SIZE_BY_REVENUE: 'Quy Mô',
          YEARS_OF_OPERATION_DISTRIBUTION: 'Phân bổ theo số năm hoạt động',
          HIGHEST_RISK_PORTFOLIOS: 'Danh mục có rủi ro cao',
          HIGHEST_RISK_PORTFOLIOS_NOTE:
            'Danh mục có nhiều công ty thuộc mức điểm Rủi ro cao, Rủi ro rất cao và Gần vỡ nợ.',
          HIGHEST_RISK_INDUSTRIES: 'Ngành có rủi ro cao',
          HIGHEST_RISK_INDUSTRIES_SUB: '(VSIC - Cấp 2)',
          HIGHEST_RISK_INDUSTRIES_NOTE:
            'Ngành có nhiều công ty trong tất cả các danh mục thuộc mức điểm Rủi ro cao, Rủi ro rất cao và Gần vỡ nợ.',
          HIGHEST_GROWTH_POTENTIAL_PORTFOLIOS:
            'Danh mục có triển vọng tăng trưởng cao nhất',
          HIGHEST_GROWTH_POTENTIAL_PORTFOLIOS_NOTE:
            'Danh mục có nhiều công ty thuộc Mức triển vọng tăng trưởng cao',
          HIGHEST_GROWTH_POTENTIAL_INDUSTRIES:
            'Ngành có triển vọng tăng trưởng cao nhất',
          HIGHEST_GROWTH_POTENTIAL_INDUSTRIES_SUB: '(VSIC - Cấp 2)',
          HIGHEST_GROWTH_POTENTIAL_INDUSTRIES_NOTE:
            'Ngành có nhiều công ty trong tất cả danh mục thuộc mức triển vọng tăng trưởng cao',
          TOTAL_HIGHEST_RISK_COMPANIES: 'Công Ty<br/>Rủi Ro Cao',
          NEW_HIGHEST_RISK_COMPANIES: 'Công Ty<br/>Rủi Ro Cao Mới',
          HIGHEST_GROWTH_POTENTIAL_COMPANIES:
            'Công Ty Có Triển Vọng<br/>Tăng Trưởng Cao',
          NEW_HIGHEST_GROWTH_POTENTIAL_COMPANIES:
            'Công Ty  Có Triển Vọng<br/>Tăng Trưởng Cao Mới',
          VIEW_ALL: 'Xem tất cả',
        },
        finance: {
          DISPLAY_TYPE: 'Xem theo loại hình:',
          CORPORATE: 'Doanh nghiệp',
          BANK: 'Ngân hàng',
          SECURITIES: 'Công ty chứng khoán',
          LIFE_INSURANCE: 'Bảo hiểm nhân thọ',
          NON_LIFE_INSURANCE: 'Bảo hiểm phi nhân thọ',
          NON_BANK: 'TCTD phi ngân hàng',
          REPORT_YEAR: 'Năm báo cáo: ',
          COMPARE_WITH: 'So sánh với: ',
          CURRENT_RATIO: 'Hệ số thanh khoản hiện thời',
          TOTAL_ASSETS: 'Tổng nợ phải trả / Tổng tài sản',
          CASH_CONVERSION: 'Vòng quay tiền mặt',
          NET_REVENUE: 'Tăng trưởng doanh thu',
          CAPITAL_ADEQUACY: 'Tỷ lệ an toàn vốn (CAR)',
          NET_INTEREST: 'Tỷ lệ thu nhập lãi thuần',
          NON_PERFORMING: 'Tỷ lệ nợ xấu nhóm 3-5',
          LOAN_DEPOSIT: 'Dư nợ tín dụng / Vốn huy động',
          STOCK_BOND: 'Thị phần môi giới cổ phiếu và trái phiếu',
          LOAN_TOTAL: 'Dư nợ tín dụng / Tổng nguồn vốn',
          COST_INCOME: 'Tỷ lệ chi phí trên thu nhập (CIR)',
          TOTAL_EQUITY: 'Tổng nợ phải trả / Tổng nguồn vốn',
          LIQUIDITY_SOLVENCY: 'Khả Năng Thanh Toán',
          ASSET_MANAGEMENT: 'Hiệu Quả Quản Lý Tài Sản',
          PROFITABILITY: 'Tỷ Suất Sinh Lời',
          BUSINESS_GROWTH: 'Khả Năng Tăng Trưởng',
          CAPITAL_ADEQUACY_PANEL: 'Khả Năng Về Vốn',
          ASSET_QUALITY: 'Chất Lượng Tài Sản',
          EARING_QUALITY: 'Chất lượng thu nhập',
          FUNDING_LIQUIDITY: 'Cơ Cấu Vốn Và Khả Năng Thanh Toán Nhanh',
          BUSINESS_POSITION: 'Vị Thế Công Ty',
          CAPITAL_EARNING: 'Tỷ Suất Sinh Lời',
          OVER_5_YEARS: ' qua 5 năm ',
          FILTERED_RATIO: 'Chỉ số của danh mục phân tích',
          COMPARE_RATIO: 'Chỉ số của danh mục phân tích và danh mục so sánh',
          RATIO: 'Tỷ lệ',
          SHOW_ON_CHART: 'Xem biểu đồ',
          PORTFOLIO: 'Danh mục',
          MEDIAN_SCORE: 'Trung vị',
          INTERQUARTILE_RANGE: 'Nhỏ nhất | Lớn nhất',
          MEDIAN_RATIO: 'Trung vị của các chỉ số',
          MAX_MIN_RATIO: 'Giá trị chỉ số Nhỏ nhất - Lớn nhất',
          SELECT_PORTFOLIO: 'Chọn danh mục',
          BLANK: 'Trống',
          CT_RT0020: 'Tỷ số thanh toán  hiện thời',
          CT_RT0019: 'Tỷ số thanh toán nhanh',
          CT_RT0018: 'Tỷ số thanh toán tiền mặt',
          CT_RT0033: 'Tổng nợ phải trả / Tổng tài sản',
          CT_RT0027: 'Tổng nợ vay / Tổng nguồn vốn',
          CT_RT0037: 'Tổng nợ vay / EBITDA',
          CT_RT0047: 'Khả năng trả lãi bằng tiền mặt',
          CT_RT0044: 'Khả năng trả lãi EBIT',
          CT_RT0046: 'Khả năng trả lãi EBITDA',
          CT_RT0045: 'Tỷ lệ bảo đảm tài sản',
          CT_RT0059: 'ROA',
          CT_RT0156: 'Tăng trưởng doanh thu',
          CT_RT0015: 'Vòng quay tiền mặt',
          NH_NB219: 'Tỷ lệ an toàn vốn (CAR)',
          NH_RT0236: 'Tỷ lệ nợ xấu nhóm 3-5',
          NH_RT0059: 'ROA',
          NH_RT0277: 'Dư nợ tín dụng / Vốn huy động',
          CK_SABBMS: 'Thị phần môi giới cổ phiếu và trái phiếu',
          CK_RT0060: 'ROE',
          CK_LTTE: 'Dư nợ tín dụng / Tổng nguồn vốn',
          CK_CTIR: 'Tỷ lệ chi phí trên thu nhập (CIR)',
          CK_RT0034: 'Tổng nợ phải trả / Tổng nguồn vốn',
          CT_RT0009: 'Thời gian thu hồi tiền hàng tồn đọng',
          CT_RT0011: 'Thời gian thanh lý hàng tồn kho',
          CT_RT0013: 'Thời gian phải trả nhà cung cấp',
          CT_RT0003: 'Vòng quay tổng tài sản',
          CT_RT0006: 'Vòng quay tài sản cố định',
          CT_RT0050: 'Biên lợi nhuận gộp',
          CT_RT0348: 'Biên lợi nhuận hoạt động',
          CT_RT0054: 'Biên lợi nhuận ròng',
          CT_RT0052: 'Biên EBIT',
          CT_RT0051: 'Biên EBITDA',
          CT_RT0060: 'ROE ',
          CK_RT0059: 'ROA',
          CT_RT0161: 'Tăng trưởng lợi nhuận sau thuế',
          CT_RT0159: 'Tăng trưởng EBIT',
          CT_RT0387: 'Tăng trưởng tài sản cố định',
          CT_RT0172: 'Tăng trưởng tài sản',
          CT_RT0174: 'Tăng trưởng vốn chủ sở hữu',
          NH_RT0249: 'Vốn cổ phần phổ thông Cấp 1/ Tổng tài sản',
          NH_RT0248: 'Tổng nguồn vốn / Tổng tài sản',
          NH_RT0266: 'Tổng dư nợ cho vay / Tổng tài sản',
          NH_RT0237: 'Dự phòng rủi ro tín dụng / Nợ xấu nhóm 3-5',
          NH_RT0238: 'Dự phòng rủi ro tín dụng / Tổng dư nợ cho vay',
          NH_RT0285: 'Tỷ lệ thu nhập lãi thuần (NIM)',
          NH_RT0252: 'Tỷ lệ chi phí trên thu nhập (CIR)',
          NH_RT0060: 'ROE ',
          NH_LATL: 'Tài sản lưu động / Tổng nợ phải trả',
          NH_RT0287: 'Chi phí huy động vốn bình quân',
          NH_RT0173: 'Tăng trưởng vốn chủ sở hữu',
          NH_RT0172: 'Tăng trưởng tổng tài sản',
          NH_RT0296: 'Tăng trưởng cho vay khách hàng',
          NH_RT0161: 'Tăng trưởng thu nhập',
          CK_OSBMS: 'Thị phần môi giới chứng khoán khác',
          CK_CIR: 'Tỷ lệ chi phí trên thu nhập (CIR)',
          CK_LTE: 'Dư nợ tín dụng / Tổng nguồn vốn',
          CK_STF: 'Vốn Ngắn Hạn',
          CK_LTF: 'Vốn Dài Hạn',
          CK_LTFLA: 'Vốn dài hạn / Tài sản thanh khoản thấp',
          CK_LASTF: 'Tài sản lưu động / Vốn ngắn hạn',
        },
        score: {},
        segment: {
          PORTFOLIO_ALLOCATION_BY_PROVINCE2: 'Phân Bổ Danh Mục Theo Địa Phận',
          PORTFOLIO_ALLOCATION_BY_PROVINCE: 'Phân Bổ Danh Mục Theo Tỉnh',
          BUSINESS_SIZE: 'Quy Mô',
          PERFORMANCE_SCORE: 'Điểm Triển Vọng Tăng Trưởng',
          PERFORMANCE_SCORE_DYNAMIC: 'Điểm Triển Vọng <br/> Tăng Trưởng',
          BASED_ON_VSIC: 'Ngành Theo VSIC',
          BY_INDUSTRY: 'Phân Bổ Danh Mục Theo Ngành',
          LAST_UPDATE_DATE: 'Ngày cập nhật: ',
          VIET_NAM: 'Việt nam',
          MEDIAN_SCORE: 'Điểm trung vị',
          TOTAL_COMPANIES: 'Số lượng công ty',
          MAIN_PROVINCE: 'Địa phận chủ yếu',
          MAIN_SECTOR: 'Ngành chính',
          MOST_BUSINESS_SIZE: 'Quy mô doanh thu phổ biến',
          YEARS_OF_OPERATION: 'Số năm hoạt động phổ biến',
          BUSINESS_SIZE_BY_REVENUE: 'Phân Bổ Danh Mục Theo Quy Mô',
          BASE_ON: ' (dựa trên ngày đăng ký kinh doanh)',
          YEARS_OF_OPERATION_DISTRIBUTION: 'Phân Bổ Theo Số Năm Hoạt Động',
          CREDIT_RISK_SCORE: 'Điểm Rủi Ro Doanh Nghiệp',
          CREDIT_RISK_SCORE_DYNAMIC: 'Điểm Rủi Ro<br/> Doanh Nghiệp',
          REVENUE: 'Doanh thu',
          YEARS_OF_OPERATION_COL: 'Số Năm Hoạt Động',
          HIGH_RISK_COMPANIES: 'Nhóm công ty rủi ro cao',
          NUMBER_OF_COMPANIES: 'Số Lượng Công Ty',
          NUMBER_OF_COMPANIES_DYNAMIC: 'Số Lượng<br/> Công Ty',
          PERCENT_OF_TOTAL_COMPANIES: '% Tỷ Trọng',
        },
      },
    },
  }),
)
